import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash-es';
import Container from 'reactstrap/lib/Container';

import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { CmsEntities } from 'client/data/models/cms';
import { buildVehiclePath, VehicleEntities, VehicleModel } from 'client/data/models/vehicle-v2';
import { buildMpgStylesPath, MpgEntities, MpgModel } from 'client/data/models/mpg';
import { MpgParams } from 'site-modules/shared/utils/mpg/params';

import { Link } from 'site-modules/shared/components/link/link';
import { FuelEconomyData } from 'site-modules/shared/components/mpg/fuel-economy-data/fuel-economy-data';

export function EvMpgUI({ content, params = null, vehicle = null, styles = null, isMobile = false, className = null }) {
  if (!(vehicle && styles)) {
    return null;
  }

  const { title, summary } = content;
  const vehicleName = content.metadata('vehicleName').value();
  const style = get(styles, '[0]');
  const { make, model, year } = params;
  const mpgUrl = `/${[make, model, year, 'mpg'].join('/')}/`;

  return (
    <div className={classnames('ev-mpg-module py-2', className)}>
      <Container>
        {!!title && <h2 className="heading-3 mb-0_75">{title}</h2>}
        {summary && <div className="mb-2_5">{summary}</div>}
        <div className="mb-1_5">
          <h3 className="heading-4 fw-medium text-gray-darker d-md-inline mb-md-0 me-md-0_5">
            {vehicleName} Fuel Economy
          </h3>
          <Link to={mpgUrl} className="text-blue-50">
            Change Vehicle
          </Link>
        </div>
        <FuelEconomyData
          className="mb-1_75"
          vehicle={vehicle}
          params={params}
          style={style}
          styles={[]}
          isMobile={isMobile}
          titleTag="h3"
          isPreview
        />
        <Link to={mpgUrl} className="text-blue-40">
          See All EV Insights <i className="icon-arrow-right4 small" aria-hidden />
        </Link>
      </Container>
    </div>
  );
}

EvMpgUI.propTypes = {
  content: CmsEntities.Content.isRequired,
  params: MpgParams,
  vehicle: VehicleEntities.MakeModelSubmodelYear,
  styles: PropTypes.arrayOf(MpgEntities.StyleMpg),
  isMobile: PropTypes.bool,
  className: PropTypes.string,
};

const EvMpgWrapper = connectToModel(EvMpgUI, {
  vehicle: bindToPath(({ params }) => params && buildVehiclePath(params), VehicleModel),
  styles: bindToPath(({ params }) => params && buildMpgStylesPath(params), MpgModel),
});

export function EvMpg({ content, ...restProps }) {
  const params = get(content, 'vehicles[0]');
  if (!params) {
    return null;
  }

  return <EvMpgWrapper {...restProps} content={content} params={params} />;
}
